/*
 * @Autor: syq
 * @Date: 2021-07-12 16:37:32
 */

import request from "../../request/request";

const getOrderBusinessDeliverDetail = async (orderNo,resultId) =>
  request({
    url: `/orderBusiness/getOrderBusinessDeliverItem?isDetail=true&qp-orderNo-eq=${orderNo}&resultId=${resultId}`,
    method: "get",
  });

 
export { getOrderBusinessDeliverDetail};
